module.exports = __webpack_public_path__ + "img/light-f-fm-Path 56@3x.211e9909.png";